import React from 'react';
import { Link } from 'react-router-dom';
import { SITE, legalEntity } from '../../config/site';
import { ROUTES } from '../../utils/constants';
import Brand from '../common/Brand';
import './PublicLayout.css';

const PublicFooter = () => (
  <footer className="public-footer">
    <div className="public-container public-footer__grid">
      <div className="public-footer__about">
        <p className="public-footer__brand"><Brand /></p>
        <p className="public-footer__note">
          {SITE.name} helps people make rental decisions. It does not make them, and it is not a credit bureau, a
          lender or a government service.
        </p>
      </div>

      <nav aria-label="Product">
        <h2 className="public-footer__heading">Product</h2>
        <ul>
          <li><Link to={{ pathname: '/', hash: '#how-it-works' }}>How it works</Link></li>
          <li><Link to="/pricing">Pricing</Link></li>
          <li><Link to="/faq">FAQ</Link></li>
        </ul>
      </nav>

      <nav aria-label="Company">
        <h2 className="public-footer__heading">Company</h2>
        <ul>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>

      <nav aria-label="Legal">
        <h2 className="public-footer__heading">Legal</h2>
        <ul>
          <li><Link to="/terms">Terms and Conditions</Link></li>
          <li><Link to="/privacy">Privacy Policy</Link></li>
        </ul>
      </nav>

      <nav aria-label="Account">
        <h2 className="public-footer__heading">Account</h2>
        <ul>
          <li><Link to={ROUTES.LOGIN}>Log in</Link></li>
          <li><Link to={ROUTES.REGISTER}>Register</Link></li>
        </ul>
      </nav>
    </div>

    <div className="public-container public-footer__legal">
      <p>
        &copy; {new Date().getFullYear()} {legalEntity()}. All rights reserved.
        {SITE.registrationNumber && <> Registration number {SITE.registrationNumber}.</>}
        {SITE.address && <> {SITE.address}.</>}
      </p>
      {SITE.supportEmail && (
        <p>
          <a href={`mailto:${SITE.supportEmail}`}>{SITE.supportEmail}</a>
        </p>
      )}
    </div>
  </footer>
);

export default PublicFooter;
